import { render, staticRenderFns } from "./SearchProperty.vue?vue&type=template&id=3b4b4f04&scoped=true"
import script from "./SearchProperty.vue?vue&type=script&lang=js"
export * from "./SearchProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4b4f04",
  null
  
)

export default component.exports